import React, { useEffect } from "react";
import paper from './paper.pdf';
export default function Papers(props){
    useEffect(()=>{
        props.setShowNavbar(true);
    });
    return(
    <div>
        <h1 style={{fontFamily:"Monsterrat",fontWeight:"bold",margin:"20px 0 50px 0",fontSize:"60px",color:"#1D3353"}}>Papers</h1>
        <div className="list-group"style={{height:"50vh"}}>
            <a href={paper}
                download="Research_Paper"
                target="_blank"
                rel="noopener noreferrer" className="list-group-item list-group-item-action" >
                <div className="d-flex w-100 justify-content-between">
                    <h5 className="mb-1">Stock Market Prediction Based on Twitter Sentiment Analysis</h5>
                </div>
                <p className="mb-1" style={{textAlign:"start"}}>Research Paper</p>
                <p style={{textAlign:"start"}}><small>Click to download and read!</small></p>
            </a>
        </div>
        {/* <div style={{display:"flex",alignItems:"center"}}> 
                <div style={{padding:"30px 30px 30px 30px",height:"100vh",width:"60vw",border:"2px solid black"}}>
                    <p style={{margin:"50px 30px 0 0",wordWrap:"break-word",textAlign:"start"}}>FaceSham app provide the interface for the users to filter their media. Initial step will be user uploading the video throught the app. The video is stored in firebase database, also onces the video is uploaded a flask api request is made which then indiates the cloud processing unit/local computer for starting the deeplearning pipeline on the input video. The result of the deep learning model is then sent back to the FaceSham app. The following flowchart diagram explains the same.</p>
                    <br></br> 
                </div>
                <div style={{width:"40vw"}}>
                <h1 style={{fontFamily:"Monsterrat",fontWeight:"bold",textAlign:"start"}}>Stock Market Prediction Based on Twitter Sentiment Analysis</h1>
                    
                </div>
            </div> */}
   
    </div>);
}